export default __webpack_public_path__ + "static/media/cabourg8.75f20baa.jpg";